/*
  Phase 3 API client — subscriptions, text→checklist, url→summary, OCR,
  frequently-bought.
*/
import axios from "axios";
import { API, getClientId } from "./api";

const http = axios.create({ baseURL: API });
http.interceptors.request.use((cfg) => {
  cfg.headers["X-Client-Id"] = getClientId();
  return cfg;
});

export const phase3Api = {
  // Subscriptions
  async listSubs() { return (await http.get("/subscriptions")).data; },
  async createSub(body) { return (await http.post("/subscriptions", body)).data; },
  async updateSub(id, patch) { return (await http.patch(`/subscriptions/${id}`, patch)).data; },
  async deleteSub(id) { return (await http.delete(`/subscriptions/${id}`)).data; },
  // Tools
  async textToChecklist(text) { return (await http.post("/text-to-checklist", { text })).data; },
  async urlSummary(url) { return (await http.post("/url-summary", { url })).data; },
  async ocr(file) {
    const fd = new FormData();
    fd.append("file", file);
    return (await http.post("/ocr", fd, { headers: { "Content-Type": "multipart/form-data" } })).data;
  },
  // Shopping
  async frequentlyBought(limit = 10) {
    return (await http.get("/shopping/frequent", { params: { limit } })).data;
  },
};
